<template>
  <div :class="final ? 'move-panel' : ''">
    <b-card-title>{{ $t("label.detalles.oferta") }}</b-card-title>
    <div v-if="cliente && delegacion && divisa">
      <b-row>
        <b-col cols="1" class="mt-5">
          <b-button disabled pill variant="primary" class="btn-number font-weight-bold">1</b-button>
        </b-col>
        <b-col lg="11" md="11" class="mt-2">
          <b-card>
            <b-card-body>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col lg="6" md="6">
                  <label class="recent-label" for="desCliente">{{ $t("label.cliente") }}</label>
                  <span id="desCliente">{{ cliente.desCliente }}</span>
                </b-col>
                <hr />
                <b-col lg="4" md="4">
                  <label class="recent-label" for="desDelegacion">
                    {{ $t("label.delegacion") }}
                  </label>
                  <span id="desDelegacion">{{ delegacion.desDelegacion }}</span>
                </b-col>
                <hr />
                <b-col v-if="transportadora" lg="7" md="7">
                  <label class="recent-label" for="transportadora">{{
                    $t("label.transportadora")
                  }}</label>
                  <span id="transportadora">{{ transportadora.descripcion }}</span>
                </b-col>
                <b-col lg="2" md="2" v-if="divisa">
                  <label class="recent-label" for="divisa">{{ $t("label.divisa") }}</label>
                  <span id="divisa">{{ divisa.simbolo }} {{ divisa.codDivisa }}</span>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-if="saldoOfertar > 0">
      <b-row>
        <b-col cols="1" class="mt-5">
          <b-button disabled pill variant="primary" class="btn-number font-weight-bold">2</b-button>
        </b-col>
        <b-col lg="11" md="11" class="mt-2">
          <b-card>
            <b-card-body>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col class="separator" v-if="!cliente.fakeCerts">
                  <span class="recent-label">{{ $t("label.saldo.restante") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold" v-if="divisa">
                    {{ divisa.simbolo }} {{ saldoRestante.toLocaleString() }}
                  </span>
                </b-col>
                <b-col>
                  <span class="recent-label">{{ $t("label.total.ofertar") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold" v-if="divisa">
                    {{ divisa.simbolo }}
                    {{ filterNumber(saldoOfertar) }}
                  </span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-header>
              <b-card-title>{{ $t("label.ofertas") }}</b-card-title>
              <template v-for="detalle in detalleSaldo">
                <div v-if="detalle.calidadDenominacion?.importe > 0" :key="detalle.id">
                  <b-row>
                    <b-col>
                      <span class="recent-label">{{ $t("label.denominacion") }}</span>
                    </b-col>
                    <b-col>
                      <span class="recent-label">{{ $t("label.ofertado") }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span
                        >{{ detalle.calidadDenominacion.denominacion.codDenominacion }}
                        {{ detalle.calidadDenominacion.desCalidad }}</span
                      >
                    </b-col>
                    <b-col>
                      <span v-if="divisa"
                        >{{ divisa.simbolo }}
                        {{ filterNumber(detalle.calidadDenominacion.importe, 2) }}</span
                      >
                    </b-col>
                  </b-row>
                </div>
              </template>
              <template v-for="calidadDenominacion in calidadesDenominacion">
                <div v-if="calidadDenominacion.importe > 0" :key="calidadDenominacion.id">
                  <b-row>
                    <b-col>
                      <span class="recent-label">{{ $t("label.denominacion") }}</span>
                    </b-col>
                    <b-col>
                      <span class="recent-label">{{ $t("label.ofertado") }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span
                        >{{ calidadDenominacion.denominacion.codDenominacion }}
                        {{ calidadDenominacion.desCalidad }}</span
                      >
                    </b-col>
                    <b-col>
                      <span v-if="divisa"
                        >{{ divisa.simbolo }}
                        {{ filterNumber(calidadDenominacion.importe, 2) }}</span
                      >
                    </b-col>
                  </b-row>
                </div>
              </template>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div v-if="fechaExpiracion && horaExpiracion && coste">
      <b-row>
        <b-col cols="1" class="mt-5">
          <b-button disabled pill variant="primary" class="btn-number font-weight-bold">3</b-button>
        </b-col>
        <b-col lg="11" md="11" class="mt-2">
          <b-card>
            <b-card-body>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col>
                  <span class="recent-label">{{ $t("label.fecha.expiracion") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold">{{
                    filterDate(fechaExpiracion)
                  }}</span>
                </b-col>
                <b-col>
                  <span class="recent-label">{{ $t("label.hora.expiracion") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold">{{ horaExpiracion }}</span>
                </b-col>
                <b-col>
                  <span class="recent-label">{{ $t("label.coste") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold">{{ coste.codParametro }}</span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-header>
              <b-row>
                <b-col v-if="cliente.pais.admiteAnonimo">
                  <span class="recent-label">{{ $t("label.anonimo") }}</span>
                  <br />
                  <span v-if="anonimo"> {{ $t("label.si") }}</span>
                  <span v-else>{{ $t("label.no") }}</span>
                </b-col>
                <b-col v-if="cliente.pais.hasTasa">
                  <span class="recent-label">{{ $t("label.tasa") }}</span>
                  <br />
                  <span v-if="!cliente.pais.hasTasaEnteros">{{ filterNumber(tasa, 5) }} %</span>
                  <span v-if="cliente.pais.hasTasaEnteros">{{ Math.round(tasa) }} x 10.000</span>
                </b-col>
              </b-row>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div v-if="ofertaPaso4Params.relleno">
      <b-row>
        <b-col cols="1" class="mt-5">
          <b-button disabled pill variant="primary" class="btn-number font-weight-bold">4</b-button>
        </b-col>
        <b-col lg="11" Smd="11" class="mt-2">
          <b-card>
            <b-card-body v-if="isShowBankField">
              <b-row class="pt-3 pb-3">
                <b-col md="12" lg="12" xl="6">
                  <label class="recent-label" for="cuentaCorriente">
                    {{ $t("label.cuentaCorriente") }}
                  </label>
                  <span id="cuentaCorriente">{{ ofertaPaso4Params.cuentaCorriente }}</span>
                </b-col>
                <hr />
                <b-col md="12" lg="12" xl="6">
                  <label class="recent-label" for="agNumeroSucursal">
                    {{ $t("label.agNumeroSucursal") }}
                  </label>
                  <span id="agNumeroSucursal">{{ ofertaPaso4Params.agNumeroSucursal }}</span>
                </b-col>
                <hr />
                <b-col md="12" lg="12" xl="6">
                  <label class="recent-label" for="ispbBanco">{{ $t("label.ispbBanco") }}</label>
                  <span id="ispbBanco">{{ ofertaPaso4Params.ispbBanco }}</span>
                </b-col>
                <b-col md="12" lg="12" xl="6">
                  <label class="recent-label" for="cnpjPersona">
                    {{ $t("label.cnpjPersona") }}
                  </label>
                  <span id="cnpjPersona">{{ ofertaPaso4Params.cnpjPersona }}</span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-header>
              <b-row class="pt-3 pb-3">
                <b-col lg="12" md="12">
                  <label class="recent-label" for="observacionesOferta">
                    {{ $t("label.observaciones") }}
                  </label>
                  <span id="observacionesOferta">{{ ofertaPaso4Params.observacionesOferta }}</span>
                </b-col>
              </b-row>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ICalidadDenominacion,
  ICliente,
  IDelegacion,
  IDetallesSaldo,
  IDivisa,
  IParametro,
  ITransportadora,
} from "@/entities";
import { IOfertaPaso4Params } from "@/services";
import VueFilters from "@/vue-filters";

@Component({
  name: "resumen-oferta",
  mixins: [VueFilters],
})
export default class ResumenOferta extends Vue {
  @Prop({ required: false, default: null }) cliente!: ICliente;
  @Prop({ required: false, default: null }) delegacion!: IDelegacion;
  @Prop({ required: false, default: null }) transportadora!: ITransportadora;
  @Prop({ required: false, default: null }) divisa!: IDivisa;
  @Prop({ required: false, default: null }) detalleSaldo!: IDetallesSaldo[];
  @Prop({ required: false, default: null }) calidadesDenominacion!: ICalidadDenominacion[];
  @Prop({ required: false, default: null }) saldoRestante!: number;
  @Prop({ required: false, default: null }) saldoOfertar!: number;
  @Prop({ required: false, default: null }) fechaExpiracion!: string;
  @Prop({ required: false, default: null }) horaExpiracion!: string;
  @Prop({ required: false, default: null }) coste!: IParametro;
  @Prop({ required: false, default: null }) anonimo!: boolean;
  @Prop({ required: false, default: null }) tasa!: number;
  @Prop({ required: false, default: null }) ofertaPaso4Params!: IOfertaPaso4Params;
  @Prop({ required: false, default: false }) isShowBankField!: boolean;
  @Prop({ required: false, default: null }) final!: boolean;

  constructor() {
    super();
  }
}
</script>

<style lang="scss" scoped>
.recent-label {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 30px;
  letter-spacing: normal;
  color: var(--secundario-prosegur-claro);
}

.btn-number {
  border-color: transparent;
  background-color: rgba(0, 0, 0, 0.03);
}

.card {
  margin: 0 0 0 0.75rem;
}

.card span {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}

.card span:hover {
  white-space: normal;
}

.card-body {
  margin: 0;
  padding: 0;
}

.card-header,
.card-text {
  padding: 1rem;
}

.separator {
  border-right-color: gainsboro;
  border-right-style: solid;
  border-right-width: 1px;
}
.move-panel {
  transition: all 1.5s ease-in-out;
  transform: translate(-25vw, 0);
}
</style>
